<script>
import { ref, computed, onMounted, watch } from 'vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SwiperCore, { Autoplay } from 'swiper/core'
import 'swiper/swiper.scss'

import {
  getStageTemplate,
  getStageTemplateList,
  getStageProjectDistribution
} from '~/api/project.api'

SwiperCore.use([Autoplay])

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    day: {
      type: Number,
      default: 1
    },
    companyId: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    // #region swiper behavior
    const swiperRef = ref(null)
    const mySwiper = computed(() => {
      return swiperRef.value.$swiper
    })
    const swiperOption = ref({
      autoplay: {
        delay: 750,
        disableOnInteraction: false
      },
      direction: 'vertical',
      slidesPerView: 5,
      loopFillGroupWithBlank: true
    })
    const onMouseover = () => {
      mySwiper.value.autoplay.stop()
    }
    const onMouseLeave = () => {
      mySwiper.value.autoplay.start()
    }
    // #endregion

    // #region init stageTemplateList
    const dataList = ref([])
    const selectedTemplate = ref(null)
    const templateList = ref([])
    const loadData = async ({ companyId, stageTemplateId, day }) => {
      const stageTemplate = await getStageTemplate({
        companyId,
        stageTemplateId
      })
      const stageList = stageTemplate.stageList || []
      const list = (
        await getStageProjectDistribution({
          companyId,
          stageTemplateId,
          day
        })
      ).data
      const res = stageList.map((el) => {
        const item = list.find((item) => item.stageId === el.stageId)
        if (item) {
          return Object.assign(item, el)
        }

        return {
          name: el.stageName,
          number: 0,
          percent: 0,
          stageId: el.stageId
        }
      })

      dataList.value = [...res]
    }

    onMounted(async () => {
      const list = await getStageTemplateList(props.companyId)
      if (list) {
        templateList.value = list
        selectedTemplate.value = list[0].stageTemplateId
        await loadData({
          companyId: props.companyId,
          stageTemplateId: selectedTemplate.value,
          day: props.day
        })
      }
    })
    // #endregion

    // #region reload when day or selectedTemplateId changed
    watch([() => props.day, selectedTemplate], async (newValues) => {
      await loadData({
        companyId: props.companyId,
        stageTemplateId: newValues[1],
        day: newValues[0]
      })
    })
    // #endregion

    return {
      mySwiper,
      onMouseLeave,
      onMouseover,
      selectedTemplate,
      dataList,
      swiperOption,
      swiperRef,
      templateList
    }
  },
  computed: {
    darkMode() {
      return this.$store.state.config.mapDarkmode
    }
  }
}
</script>

<template>
  <div
    :class="{ 'dark-mode': darkMode }"
    @mouseover="onMouseover"
    @mouseleave="onMouseLeave"
    class="distrib-dia__warpper"
  >
    <div class="distrib-dia__header">
      <div class="title">在建工地阶段分布</div>
      <div style="width:115px">
        <el-select
          v-model="selectedTemplate"
          :popper-append-to-body="true"
          popper-class="distrib-selector"
          placeholder="请选择"
        >
          <el-option
            v-for="item in templateList"
            :key="item.stageTemplateId"
            :label="item.stageTemplateName"
            :value="item.stageTemplateId"
          />
        </el-select>
      </div>
    </div>
    <swiper ref="swiperRef" :options="swiperOption" class="swiper">
      <swiper-slide v-for="item in dataList" :key="item.name">
        <div class="swiper-item">
          <div class="swiper-item__name">{{ item.name }}</div>
          <div class="swiper-item__number">
            <div style="margin-right: 30px;opacity:.7;">{{ item.number }}</div>
            <div
              style="font-weight: 500;width:35px;text-align: right;color:#444;"
            >
              {{ `${item.percent}${item.percent === '--' ? '' : '%'}` }}
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<style lang="scss" scoped>
:deep(.el-input__inner) {
  width: 100px;
}
:deep(.el-input--suffix) {
  width: 130px;
  input {
    text-align: right;
  }
}
.distrib-dia__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 400;
    color: #444444;
  }
}
:deep(.el-input input) {
  padding: 0;
  border: none;
  background: inherit;
  color: #d6d6d6;
}
:deep(.el-input input::placeholder) {
  color: #d6d6d6;
}
:deep(.el-icon-arrow-up::before) {
  color: #d6d6d6;
}

.distrib-selector {
  .el-select-dropdown__item.selected {
    color: #00bfd1;
  }
}
.swiper-container {
  height: 180px;
}

.swiper-item {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #444444;
}
.swiper-item__number {
  display: flex;
}
.distrib-dia__warpper.dark-mode {
  .title {
    color: #ffcf66;
  }
  .swiper-item__name {
    color: #ffffff;
  }
  .swiper-item__number {
    color: #ffffff;
  }
}
</style>
